import React from "react";
import { Link } from "react-router-dom";
const NotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-screen  bg-black">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-red-600">404</h1>
        <h2 className="text-2xl mt-4 text-white">Oops! Page not found.</h2>
        <p className="text-white mt-2 ">
          The page you're looking for doesn't exist or has been removed or moved.
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-red-600 text-white text-lg font-semibold rounded-md hover:bg-red-700 transition duration-300"
          >
            Go Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
